// Поиск диалога для ⌘K (задача D5): `GET /api/v1/dialogs/lookup?q=48213` → `{ dialogId }`; нет такого диалога — 404 с
// текстом сервера. Маршрут и форму ответа (`LookupSchema`, контракт D8) делает D8. План PH: `q` — и ссылка на чат Омнидеска
// (или id чата); что ввели — решает общий с сервером `ticketRefOf`.
import { LookupSchema, ticketRefOf, type TicketRef } from '@contract/index.js';
import { apiGet } from '../client';

export const DIALOG_LOOKUP_PATH = '/api/v1/dialogs/lookup';

export { ticketRefOf, type TicketRef };

/** Строка `q` для поиска диалога: номер тикета или id чата Омнидеска. */
export function lookupQueryOf(ref: TicketRef): string {
  return ref.kind === 'number' ? String(ref.number) : ref.id;
}

/** Id диалога по номеру тикета или чату Омнидеска. Нет диалога — `ApiError` 404 с текстом сервера. */
export async function lookupDialog(ref: TicketRef): Promise<string> {
  const found = await apiGet(`${DIALOG_LOOKUP_PATH}?${new URLSearchParams({ q: lookupQueryOf(ref) }).toString()}`, LookupSchema);
  return found.dialogId;
}
